import { Injectable } from "@angular/core";
import { LogisticsService } from "../../logistics.service";
import { StudyReportDeliveryEditInfo } from "../../../model/logistics/study-report/study-report-delivery-edit-info";
import { PatientView } from "src/app/model/patient";
import { PdfService } from "../../pdf.service";
import { StudyReportService } from "../../study-report/study-report.service";
import { PacsLinkedImageService } from "../../pacs-linked-image.service";
import { ImagePrintService } from "../../image-print.service";

@Injectable()
export class StudyReportDeliveryWizard {
  private studyReportDeliveryEditInfo: StudyReportDeliveryEditInfo;
  private studyReportId: number;

  constructor(
    private logisticsService: LogisticsService,
    private pdfService: PdfService,
    private imagePrintService: ImagePrintService,
    private pacsLinkedImageService: PacsLinkedImageService,
    private studyReportService: StudyReportService
  ) {}

  async initialize(studyReportId: number) {
    this.studyReportId = studyReportId;
    this.studyReportDeliveryEditInfo =
      await this.logisticsService.getStudyReportDeliveryEditInfo(studyReportId);
  }

  async sendMail() {
    await this.studyReportService.sendMailById(this.studyReportId);
  }

  async printStudyReport() {
    const reportViewer = await this.studyReportService.getStudyReportPdf(
      this.studyReportId
    );

    this.pdfService.base64ToPdfPrint(reportViewer.ReportBase64, "", true);

    const linkedImages =
      await this.pacsLinkedImageService.getLinkedImagesBase64(
        this.studyReportId
      );

    linkedImages.forEach((i) => {
      this.imagePrintService.base64ToImagePrint(i, "", true);
    });
  }

  getStudyReportDeliveryEditInfo(): StudyReportDeliveryEditInfo {
    return this.studyReportDeliveryEditInfo;
  }

  setDeliveryObservation(deliveryObservation: string): void {
    this.studyReportDeliveryEditInfo.DeliveryObservation = deliveryObservation;
  }

  getPatiet(): PatientView {
    return this.studyReportDeliveryEditInfo.PatientView;
  }

  isValidDelivery(): boolean {
    return this.studyReportDeliveryEditInfo
      ? this.studyReportDeliveryEditInfo.ValidMedicalOrderAmount &&
          this.studyReportDeliveryEditInfo.ValidMedicalOrderState
      : false;
  }

  async finalizeDelivery(): Promise<boolean> {
    return this.logisticsService.studyReportDelivery(
      this.studyReportId,
      this.studyReportDeliveryEditInfo.DeliveryObservation
    );
  }
}
